// extracted by mini-css-extract-plugin
module.exports = {"poweredByWrapper":"style_poweredByWrapper__2dXeJ"};